import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Button, Stack, Typography } from '@mui/material';

import { useApp } from '@system/app';

const PageForbidden = () => {
  const { mainMenu } = useApp();

  useEffect(() => {
    mainMenu.set([]);
  }, [mainMenu]);

  return (
    <Stack
      height="calc(100vh - 40vh)"
      minHeight="300px"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      flexDirection="column"
    >
      <Stack></Stack>

      <Stack gap={4}>
        <Typography
          sx={{
            fontSize: 48,
            color: theme => theme.palette.error.main,
          }}
          variant="h1"
          paragraph
        >
          В доступе отказано
        </Typography>

        <Typography variant="h3">
          У вас нет доступа к данному разделу сайта.
        </Typography>

        <Typography
          variant="h3"
          paragraph
        >
          Обратитесь к администратору для получения доступа.
        </Typography>

        <Button
          color="primary"
          variant="contained"
          sx={{
            '& a': {
              color: '#d7d7d7',
              '&:hover': { color: 'white' },
            },
          }}
          data-testid="closeButton"
        >
          <Link to="/">Перейти на Главную страницу</Link>
        </Button>
      </Stack>
    </Stack>
  );
};

export default PageForbidden;
